import { BaseControl, ControlPosition } from "./BaseControl.js";
import { Pano } from "../Pano.js";
import { Resource } from "../../model/Resource.js";

export class ControlOpen extends BaseControl {
    private _message: HTMLDivElement;

    constructor(pano: Pano) {
        super(pano, ControlPosition.RIGHT);

        this.element.classList.add("control-button");
        this.element.innerHTML = `
        <div class="control-button-icon icon-520"></div>
        `;

        this.element.addEventListener("click", () => {
            if (this.pano.current)
                window.open(Resource.SITE + "#video/" + this.pano.current.id, "_pano");
        });
    }
}